<div class="container" [ngClass.xs]="'extra-small-scr-container'">
    <div class="header-container">
        <div class="header-column-one" fxFlex = "28%">
            <h3 class="title">Date</h3>
        </div>
        <div class = "header-column-two" fxFlex = "36%">
            <h3 class="title">Title and Description</h3>
        </div>
        <div class = "header-column-three" fxFlex = "20%">
            <h3 class="title">Status</h3>
        </div>
        <!-- <div class= "header-column-four">
            <h3>Type</h3>
        </div> -->
    </div>
    <div class="content-container" [ngClass.xs] = "'extra-small-scr-content-container'">
        <mat-card appearance="outlined" (click) = "openMeetingTitleDialog()" class="card-container">
            <mat-list>
                <mat-list-item>
                    <div class="list-column-one" fxFlex = "25%">
                        <div class="list-col-one-inner-container" [ngClass.xs]="'extra-smallscr-list-col-one-inner-container'">
                            <mat-icon [ngClass.xs] = "'extra-small-scr-circle-icon'">check_circle_outline</mat-icon>
                        </div>
                        <div>
                            <h3 [ngClass.xs] = "'extra-small-scr-date'">{{currentDate}}</h3>
                            <h3 [ngClass.xs] = "'extra-small-scr-date'">&#64; 2:00PM</h3>
                        </div>
                    </div>
                    <div class="list-column-two" fxFlex = "40%">
                        <div>
                            <h3 class="list-title" [ngClass.xs] = "'extra-small-scr-list-col-two-title'">Agora UI Discussion</h3>
                        </div>
                        <div>
                            <ul class = "list-container" *ngIf = "deviceLg || deviceXl">
                                <li class = "list-item-container" [ngClass.xs] = "'extra-small-scr-list-item-container'">Lakhmi kala M</li>
                                <li class = "list-item-container" [ngClass.xs] = "'extra-small-scr-list-item-container'">Shivakumar M</li>
                                <li class = "list-item-container" [ngClass.xs] = "'extra-small-scr-list-item-container'">Chandrasekar K</li>
                                <li class = "list-item-container" [ngClass.xs] = "'extra-small-scr-list-item-container'">3 more...</li>
                            </ul>
                            <ul class = "list-container" *ngIf = "deviceXs || deviceMd">
                                <li class = "list-item-container" [ngClass.xs] = "'extra-small-scr-list-item-container'">Lakhmi kala M</li>
                                <li class = "list-item-container" [ngClass.xs] = "'extra-small-scr-list-item-container'">3 more...</li>
                            </ul>
                        </div>
                        <div>
                            <h3 [ngClass.xs] = "'extra-small-scr-agenda'">Agenda - 1: Description</h3>
                        </div>
                    </div>
                    <div class="list-column-three" fxFlex = "27%">
                        <div class="list-column-three-inner">
                            <div class="list-col-three-inner-content-container">
                                <div>
                                    <mat-progress-bar mode="determinate" value="40" class="progress"></mat-progress-bar>
                                    <h5 [ngClass.xs] = "'extra-small-scr-list-col-three-content'">MOM to be shared</h5>
                                </div>
                                <div>
                                    <mat-icon [ngClass.xs] = "'extra-small-scr-vert-icon'">more_vert</mat-icon>
                                </div>
                            </div>
                            <div class="list-col-three-inner-container-two">
                                <button class="mom-btn" mat-raised-button [ngClass.xs] = "'extra-small-scr-mom-btn'">MOM</button>
                                <button class="mom-btn" mat-raised-button [ngClass.xs] = "'extra-small-scr-mom-btn'">Attachments</button>
                            </div>
                        </div>
                    </div>
                </mat-list-item>
            </mat-list>
        </mat-card>
        <div>
            <app-pagination></app-pagination>
        </div>
    </div>
</div>